export default __webpack_public_path__ + "static/media/angpao.a17e8bc7.webp";